import CheckboxGroup from "@/components/CheckboxGroup";

import { useFilterContext } from "../FilterContext";

const FilterItemConnectingAirports = () => {
  const { filterData, setFilterData, filterOptions, filterOptionsCount } = useFilterContext();

  return (
    <CheckboxGroup
      options={filterOptions.connectingAirportsOptions.map((item) => ({
        ...item,
        label: `${item.label} (${filterOptionsCount["airports"][item.value]?.progress}/${
          filterOptionsCount["airports"][item.value]?.total
        })`.replaceAll("undefined", "0"),
      }))}
      value={
        filterData.connectingAirports.length > 0
          ? filterData.connectingAirports
          : filterOptions.connectingAirportsOptions.map(({ value }) => value)
      }
      onChange={(value) => {
        setFilterData({
          connectingAirports:
            value.length === filterOptions.connectingAirportsOptions.length ? [] : value,
        });
      }}
    />
  );
};

export default FilterItemConnectingAirports;
